import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Box, Stack, Typography, styled } from "@mui/material";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";

const DisclaimerContainer = styled(Box)(({ variant }) => ({
  padding: "16px 32px",
  borderRadius: "8px",

  gap: "12px",
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",

  ...(variant === "important" && {
    backgroundColor: "#FBE8E8",

    border: "1.5px solid rgba(207, 30, 60, 1)",
  }),

  ...(variant === "notice" && {
    backgroundColor: "#F5F0F7",

    border: "1.5px solid rgba(63, 42, 85, 1)",
  }),
}));

export default function Disclaimer({ variant, children }) {
  const { t } = useTranslation();

  return (
    <DisclaimerContainer variant={variant}>
      <Stack direction="row" gap="8px">
        {variant === "important" && (
          <Stack direction="column" gap="12px">
            <ErrorRoundedIcon color="primary" />
          </Stack>
        )}
        <Typography color="primary" variant="body1" fontWeight={700}>
          {variant === "important" && t("important")}
          {variant === "notice" && t("notice")}
        </Typography>
      </Stack>
      <Stack gap="12px" direction="column">
        {children}
      </Stack>
    </DisclaimerContainer>
  );
}
